import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TOOLBAR_PICTURE } from '@editor/src/img/pageIndex';
import i18n from '@i18next/i18n';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import { TDWActionType, TDWModuleType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

export const config = {
    id: ActionType.INSERT_PICTURE,
    icon: TOOLBAR_PICTURE,
    content: i18n.t('图片'),
    twdConfig: {
        module: TDWModuleType.PC_TOOLBAR_INSERT,
        action: TDWActionType.PICTURES,
        notReportVer5: true,
    },
};

export const INSERT_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        tooltip: i18n.t('插入图片'),
        icon: <img src={config.icon} alt={''}/>,
        // 非桌面端本地编辑需跟随离线自动disable
        respectOffline: !ENV.IS_PC_LOCAL_EDIT,
    },
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: wrapIdForBig(config.id),
        icon: <img src={config.icon} alt={''}/>,
        text: config.content,
        style: {
        },
        tooltip: i18n.t('插入图片'),
        // 非桌面端本地编辑需跟随离线自动disable
        respectOffline: !ENV.IS_PC_LOCAL_EDIT,
    },
    {
        name: wrapIdForBig(`${ActionType.INSERT_PICTURE}-parent`),
        icon: <img src={config.icon} alt={''}/>,
        text: config.content,
        style: {
        },
        // 非桌面端本地编辑需跟随离线自动disable
        respectOffline: !ENV.IS_PC_LOCAL_EDIT,
    },
];
